// src/services/paths/pathfinderMission.ts
// The mission facts pathfinder is told about a mission. Both the planner
// request (/path/find, SmartPathBuilder) and the drive-model request
// (/path/simulate, RobotPathClient) carry them, so they are derived here once.

import { Mission } from '../../db';
import { MapCalculationPositionStorage } from '../../db/local_storage';

export type PathfinderMissionType = 'Grid' | 'Zone' | 'ZoneInterleave';

/** Mirrors pathfinder's parse_mission_type(). */
export function pathfinderMissionType(mission: Mission): PathfinderMissionType {
  if (mission.is_zone_mission()) {
    return mission.is_zone_interleave_mission() ? 'ZoneInterleave' : 'Zone';
  }

  return 'Grid';
}

/**
 * The robot's arm-centred origin shift (field_param bit 2): the GNSS target
 * sits ~1 m short of every core along the approach heading. Pathfinder's drive
 * model runs with it, so send the exact predicate to_ros_msg puts into
 * field_param (job flag OR the local 'Arm' navigation origin).
 */
export function implementsCenteredNavigation(mission: Mission): boolean {
  return Boolean(mission.getJob()?.implement_centerted_navigation) || MapCalculationPositionStorage.get() === 'Arm';
}
